import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-entity-name-number-record',
  standalone: true,
  templateUrl: './entity-name-number-record.component.html',
  styleUrl: './entity-name-number-record.component.scss'
})
export class EntityNameNumberRecordComponent {
  @Input() name = '';
  @Input() numberFormatted? = '';
  @Input() prefix = '';
  @Input() iconClass = '';
  @Output() handleClick = new EventEmitter<MouseEvent>();
}
